export default {
  mainChamber: 'Furnace Overview',
  chamber: 'Chamber {subSystemId}',
};
